import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import sidebarHelper from "../../../helpers/sidebar";

export default function UserMenu({ openItem = null, activeItem = null }) {
  return (
    <li
      className={`nav-item has-treeview 
        ${sidebarHelper.checkOpenItem(openItem, "manage-users")} `}
    >
      <a
        href="# "
        className={`nav-link  
        ${sidebarHelper.checkActiveItem(openItem, "manage-users")} `}
      >
        <i class="nav-icon fa hl-user"></i>

        <p>
          مدیریت کاربران ها
          <i className="right fa fa-angle-left"></i>
        </p>
      </a>

      <ul className="nav nav-treeview">
        <li className="nav-item">
          <Link
            to="/user/manage/all"
            className={`nav-link  
            ${sidebarHelper.checkActiveItem(activeItem, "list-user")} `}
          >
            <i class="fa fa-list nav-icon"></i>
            <p>لیست کاربران</p>
          </Link>
        </li>
      </ul>
    </li>
  );
}
